const KEY = 'gl.auth.return.v1';
const TTL = 30 * 60 * 1000;
const hasControl = (value: string, includeSpace = false) => Array.from(value).some(char => char.charCodeAt(0) <= (includeSpace ? 32 : 31));

export function safeReturnPath(value: unknown): string | null {
  if (typeof value !== 'string' || value.length > 4096 || !value.startsWith('/') || value.startsWith('//') || value.includes('\\') || hasControl(value, true)) return null;
  try {
    const url = new URL(value, 'https://glauncher.kz');
    const decoded = decodeURIComponent(url.pathname);
    if (url.origin !== 'https://glauncher.kz' || decoded.startsWith('//') || decoded.includes('\\') || hasControl(decoded)) return null;
    if (/^\/(login|register|verify-email|forgot-password|reset-password)(\/|$)/.test(decoded)) return null;
    return url.pathname + url.search + url.hash;
  } catch { return null; }
}

export function authReturnPath(search: string, state?: unknown): string {
  const fromState = state && typeof state === 'object' ? (state as { from?: unknown }).from : null;
  const explicit = safeReturnPath(new URLSearchParams(search).get('next')) || safeReturnPath(fromState);
  if (explicit) return explicit;
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved && typeof saved.time === 'number' && Date.now() - saved.time >= 0 && Date.now() - saved.time < TTL) return safeReturnPath(saved.path) || '/';
  } catch { /* A disabled browser store does not prevent login. */ }
  return '/';
}

export function rememberAuthReturnPath(path: string) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ path: safeReturnPath(path) || '/', time: Date.now() })); } catch { /* Optional OAuth continuation. */ }
}
export function clearAuthReturnPath() { try { sessionStorage.removeItem(KEY); } catch { /* Optional storage. */ } }
export function authLink(path: '/login' | '/register' | '/verify-email', target: string) {
  return `${path}?next=${encodeURIComponent(safeReturnPath(target) || '/')}`;
}
